import axios from "axios";

// Runtime config (set in public_html/config.js for cPanel deploys)
const RUNTIME_URL = (typeof window !== "undefined" && window.__API_URL__) || "";
export const BACKEND_URL = RUNTIME_URL || process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// attach Bearer fallback
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("auth_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function formatError(detail) {
  if (detail == null) return "Noe gikk galt. Prøv igjen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}
